module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-reports container is-fluid"
  }, [_c('div', {
    staticClass: "container container-inner"
  }, [_c('div', {
    staticClass: "columns is-flex is-gapless is-multiline"
  }, [_c('div', {
    staticClass: "column content content-main is-right"
  }, [(_vm.dataReports) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.dataReports.title) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.dataReports && _vm.dataReports.content) ? _c('markdown', {
    attrs: {
      "source": _vm.dataReports.content
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns is-flex is-multiline has-text-centered"
  }, [(_vm.dataExisting) ? _c('div', {
    staticClass: "column",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "box color-gray-lighter-bg",
    staticStyle: {
      "min-height": "200px"
    }
  }, [_c('div', {
    staticClass: "subtitle font-bold",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.dataExisting.title) + "\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.dataExisting.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.dataExisting.content))])])]) : _vm._e(), _vm._v(" "), (_vm.dataRegister) ? _c('div', {
    staticClass: "column",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "box color-gray-lighter-bg",
    staticStyle: {
      "min-height": "200px"
    }
  }, [_c('div', {
    staticClass: "subtitle font-bold",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.dataRegister.title) + "\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.dataRegister.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.dataRegister.content))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.dataRegisterHow) ? _c('a', {
    staticStyle: {
      "font-size": "0.9em",
      "display": "block",
      "margin-top": "10px"
    },
    attrs: {
      "href": _vm.dataRegisterHow.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.dataRegisterHow.content))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.dataSurvey) ? _c('div', {
    staticClass: "column",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "box color-gray-lighter-bg",
    staticStyle: {
      "min-height": "200px"
    }
  }, [_c('div', {
    staticClass: "subtitle font-bold",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.dataSurvey.title) + "\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.dataSurvey.link
    }
  }, [_vm._v(_vm._s(_vm.dataSurvey.content))])])]) : _vm._e(), _vm._v(" "), (_vm.dataRegister) ? _c('div', {
    staticClass: "column",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_vm._m(0)]) : _vm._e()])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box color-gray-lighter-bg",
    staticStyle: {
      "min-height": "200px",
      "opacity": "0.01"
    }
  }, [_c('a', {
    staticClass: "button",
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("<      >")]), _vm._v(" "), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c5b5fb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reports.vue
// module id = 986
// module chunks = 1